import { ReferralSearchParametersDto, ReferralService } from 'common/api';
import { serviceRequest } from 'utils/http';

export function searchReferralsAPI(
  searchParameters: ReferralSearchParametersDto
) {
  return serviceRequest(() =>
    ReferralService.referralControllerSearch(searchParameters)
  );
}
